console.log("init Proteus Treatments -- v1.05");

// Constants for paths and quantities
const TOOTHPASTE_TEST_PATH = "/products/toothpaste-test";
const TOOTHPASTE_MIN_QUANTITY = 1;
const TOOTHPASTE_TEST_MIN_QUANTITY = 1;
const MIN_QUANTITY = 1;

if(window.location.href.indexOf("/products/payment-protection") > -1){
  window.location.href = "/";
}

if(window.location.href.indexOf("qa=zaymo") > -1 || window.sessionStorage.getItem("[WELL-26]")){

  console.log("init [WELL-26] v1")

  waitForElement('body').then(doc => {
    doc.insertAdjacentHTML("afterbegin", `
    <style>
    [data-product-id="7939506372661"]{
      display: none;
    }
    </style>  
    `);
  })

  window.sessionStorage.setItem("[WELL-26]", true);
  console.log(`init Z treatment`);

  const var_id = 44614718455861;
  const selling_plan_id = '2351759413';
  const custom_props = {
    '_source': '[WELL-26]'
  };

  const random_number = Math.floor(Math.random() * 1001);

  fetch('/cart.js').then(res => res.json()).then(cart => {

    window.cart_data = cart;

    const anySellingPlanExists = cart.items.some(item => !!item.selling_plan_allocation);
    const hasThatVariant = cart.items.some(item => (item.variant_id ?? item.id) === Number(var_id));

    // if (!hasThatVariant && cart.items.length > 0) {
    if (!hasThatVariant) {

      console.log("add item");

      // Otherwise, add to cart and then checkout
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: var_id,
          quantity: 1,
          properties: custom_props,
          selling_plan: selling_plan_id
        })
      }).then(res => res.json()).then(data => {

        console.log('Item added to cart:', data);
        // window.location.href = "/checkout";
      });
    }

  }).catch(err => {
    console.error('Cart fetch or ATC failed:', err);
  });

  /* 
  observeSelector('button.btn-checkout', checkout_btn => {

    console.log(`observing checkout_btn`);

    let mask_id = random_number;
    checkout_btn.insertAdjacentHTML("beforebegin", `
      <div class="js-checkout-mask--${mask_id}" 
      style="cursor: pointer;
      position: relative;
      height: 3rem;
      z-index: 9999;
      margin-bottom: -3rem !important;"></div>`);

    console.log(`inserting .js-checkout-mask--${mask_id}`);

    waitForElement(`.js-checkout-mask--${mask_id}`).then(mask => {

      console.log(`targeting .js-checkout-mask--${mask_id}`);

      mask.addEventListener("click", (e) => {

        e.preventDefault();
        e.stopPropagation();

        fetch('/cart.js')
        .then(res => res.json())
        .then(cart => {

          // window.cart_data = cart;

          const anySellingPlanExists = cart.items.some(item => !!item.selling_plan_allocation);

          if (anySellingPlanExists) {
            console.log('Selling plan item already exists in cart. Going to checkout.');
            window.location.href = "/checkout";
            return;
          }

          // Otherwise, add to cart and then checkout
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              id: var_id,
              quantity: 1,
              properties: custom_props,
              selling_plan: selling_plan_id
            })
          })
          .then(res => res.json())
          .then(data => {
            console.log('Item added to cart:', data);
            window.location.href = "/checkout";
          });
        })
        .catch(err => {
          console.error('Cart fetch or ATC failed:', err);
        });

      })
    }).catch();
  });
  */

} 

const is_returning_user = Object.keys(localStorage).some(key => key.startsWith("[WELL"));

// [WELL-23]v1
if(window.location.href.indexOf("/products/") > -1){
  waitUntil(() => {
    return window.localStorage.getItem("[WELL-23] // 1.0") == "1" || window.location.href.indexOf("qa=WELL-23&v=v1") > -1
  }).then(() => {

    waitForElement('.save-main.skio-group-container.skio-group-container--selected').then(sub => {
      waitForElement('.one-time-main.skio-group-container').then(otp => {

        waitUntil(() => {
          return document.querySelectorAll('.js-onetime').length > 0;
        }).then(() => {
          
          setTimeout(() => {
            otp.click();  
            otp.classList.add("skio-group-container--selected");
            console.log("DO WELL-23 open OTP");

            // make sure the prices are correctly initialized (skio sometimes clunks)
            let elapsed = 0;
            const interval = setInterval(() => {
              
              if (document.querySelectorAll('.one-time-main.skio-group-container--selected').length > 0 && 
                  document.querySelector('[skio-onetime-price]').innerHTML.indexOf("</s>") == -1) {
                // clearInterval(interval); // Stop once replaced
                sub.click();
                otp.click();
                console.log('Text replaced.');
              }
            
              elapsed += 100;
              if (elapsed >= 25000) {
                clearInterval(interval); // Stop after 25 seconds
                console.log('Stopped checking.');
              }
            }, 100);
            
          }, 200);
          
        }).catch();
  
      }).catch();
    }).catch();
  }).catch();
}

// START [WELL-02]
console.log("init [WELL-02] v1 -- 0.07");

if(window.location.href.indexOf("/products/charcoal-toothpaste") > -1 ||
    window.location.href.indexOf("/products/cinnamint-toothpaste") > -1 ||
    window.location.href.indexOf("/products/toothpaste") > -1 ||
    window.location.href.indexOf("/products/strawberry-toothpaste") > -1 ||
    window.location.href.indexOf("/products/vanilla-berry-toothpaste") > -1 ||
    window.location.href.indexOf(TOOTHPASTE_TEST_PATH) > -1){

  if(window.location.href.indexOf("#cart") > -1){
    waitForElement('[href="#offcanvas-cart"]').then(cart_trigger => {
      setTimeout(() => {
        cart_trigger.click();
      }, 500);
    }).catch();
  }

  waitForElement('label.buy_type.onetime > span, label.one-time-main.skio-group-container').then(one_time => {

    // Check if Black Friday mode is enabled from theme settings
    const isBlackFridayMode = window.Shopify && window.Shopify.theme && window.Shopify.theme.settings && 
                              window.Shopify.theme.settings.black_friday_mode === true;
    
    // Set discount text based on mode
    const discount1Text = isBlackFridayMode ? "Save 20% off" : "Full Price";
    const discount3Text = isBlackFridayMode ? "Save 20% off" : "Save $6 when you buy";
    const discount6Text = isBlackFridayMode ? "Save 20% off" : "Save $18 when you buy";

    one_time.insertAdjacentHTML("beforeend", `
    
    <style>

    [data-selected-plan] .skio-discount-badge {
      position: absolute;
      top: 0;
      right: 0;
      border-radius: 0 10px;
      font-size: 10px;
      background: #e15e54;
      color: #fff;
      padding: 6px 16px;
      text-align: center;
      letter-spacing: 2px;
    }

    /*
    .ocu-popup {
      display: none!important;
    }
    */

    .js-onetime,
    .js-onetime--savings{
      display: none;
    }

    input.once-subscription:checked ~ .subscription_area_inner_once .js-onetime--savings,
    [data-selected-plan="one-time"] .js-onetime--savings{
      display: block;
    }
      
    input.once-subscription:checked{
      margin-top: 12px;
    }

    .skio-group-container--selected,
    .save-main.skio-group-container{
      padding-top: 30px !important;
    }

    input.once-subscription:checked ~ .subscription-info-main,
    [data-selected-plan="one-time"] input[skio-one-time] .subscription-info-main{
      padding-top: 27px;
    }
    
    input.once-subscription:checked ~ .subscription_area_inner_once .js-onetime,
    [data-selected-plan="one-time"] .js-onetime{
      display: grid;
      grid-template-columns: 1.5fr 1.5fr 1.5fr;
      column-gap: 1rem;
      width: 100%;
      margin: 1em 2rem 1.5rem 0;
    }

    [data-selected-plan="one-time"] .js-onetime{
      margin: 1em 0 0 0;
    }
    
    .js-onetime label {
      display: inline-block;
      text-align: center;
      cursor: pointer;
      position: relative;
    }

    .js-onetime label input{
      display: none;
    }
    
    /* Style the span inside the labels */
    .js-onetime label > span {
      display: block;
      padding: 10px;
      border: 2px solid #ccc;
      border-radius: 10px;
      box-sizing: border-box;
      transition: all 0.3s ease;
    }
    
    /* Highlight the label when the corresponding input is checked */
    .js-onetime input:checked + span {
      background: #e15e54;
      border-color: #e15e54;
      color: #fff;
    }
    
    /* Style the text inside the span */
    .js-onetime label span small {
      display: block;
      font-size: 12px;
      margin: 5px 0;
    }
    
    .js-onetime label span h2 {
      font-weight: 900;
      margin: 0;
      font-size: 18px;
      color: inherit;
    }

    [data-selected-plan] .js-onetime label span h2 {
      font-weight: 400;
    }

    .js-button-mask{
      position: absolute;
      top: 3rem;
      right: -1rem;
      width: calc(100% - 140px);
      height: 50px;
      cursor: pointer;
      /*  background: blue; */
    }

    [data-selected-plan] .js-button-mask{
      top: 0;
      right: 0;
      width: calc(100% - 105px);
      height: 100%;
    }

    @media(max-width: 768px){
      .js-button-mask{
        top: -5.75rem;
      }
      [data-selected-plan] .js-button-mask{
        top: 0;
      }
    }

    </style>

    <div class="percentage__discount-container js-onetime--savings skio-discount-badge">
      <span>Save 0 %</span>
    </div>
    
    <div class="js-onetime">
    
      <label class="js-onetime--size" for="size_one">
        <input class="once-subscription" type="radio" name="one_time_size" value="1" id="size_one">
        <span>
          <small>${discount1Text}</small>
          <h2>1 tube</h2>
        </span>
      </label>

      <label class="js-onetime--size" for="size_three">
        <input class="once-subscription" type="radio" name="one_time_size" value="3" id="size_three" checked>
        <span>
          <small>${discount3Text}</small>
          <h2>3 tubes</h2>
        </span>
      </label>

      <label class="js-onetime--size" for="size_six">
        <input class="once-subscription" type="radio" name="one_time_size" value="6" id="size_six">
        <span>
          <small>${discount6Text}</small>
          <h2>6 tubes</h2>
        </span>
      </label>

    </div>

    `);

    // Set body attribute for CSS targeting on all toothpaste pages
    document.body.setAttribute('data-toothpaste-page', 'true');
    console.log('Set data-toothpaste-page attribute on body');

    // Set buy once as default for ALL toothpaste pages
    const setOneTimeDefault = () => {
      const oneTimeRadio = document.querySelector('input[skio-one-time]');
      const oneTimeContainer = document.querySelector('.one-time-main.skio-group-container');
      const subscriptionContainer = document.querySelector('.save-main.skio-group-container');
      
      console.log('Attempting to set one-time default', {
        oneTimeRadio: !!oneTimeRadio,
        oneTimeContainer: !!oneTimeContainer,
        subscriptionContainer: !!subscriptionContainer
      });
      
      if(oneTimeRadio && !oneTimeRadio.checked) {
        oneTimeRadio.click();
        console.log('Clicked one-time radio');
      }
      
      if(oneTimeContainer && !oneTimeContainer.classList.contains('skio-group-container--selected')) {
        oneTimeContainer.click();
        console.log('Clicked one-time container');
      }
      
      if(subscriptionContainer && subscriptionContainer.classList.contains('skio-group-container--selected')) {
        subscriptionContainer.classList.remove('skio-group-container--selected');
        console.log('Removed selected class from subscription');
      }
      
      if(oneTimeContainer) {
        oneTimeContainer.classList.add('skio-group-container--selected');
        console.log('Added selected class to one-time');
      }
    };
    
    // Try multiple times with different delays
    setTimeout(setOneTimeDefault, 0);
    setTimeout(setOneTimeDefault, 100);
    setTimeout(setOneTimeDefault, 500);
    setTimeout(setOneTimeDefault, 1000);
    
    // Also observe for when elements are added
    observeSelector('.one-time-main.skio-group-container', setOneTimeDefault);
    observeSelector('input[skio-one-time]', setOneTimeDefault);

    // Special handling for toothpaste-test to allow quantity 1 for 3-tube option
    if(window.location.href.indexOf(TOOTHPASTE_TEST_PATH) > -1){
      
      // Set body attribute for CSS targeting
      document.body.setAttribute('data-toothpaste-test', 'true');
      console.log('Set data-toothpaste-test attribute on body');
      
      window.onClickQtyPlusMinus = (btn) => {
        const input = btn.closest('.quantity-wrapper').querySelector('input')
        const inputValue = Number(input.value)
        const minusBtn = btn.closest('.quantity-wrapper').querySelector('[data-mode="minus"]')

        if (btn.dataset.mode === 'plus') {
            input.value = inputValue + 1
            minusBtn.style.display = "";  // Show minus when increasing
        } else {
            if (input.value > MIN_QUANTITY) {
                input.value = inputValue - 1
                if (input.value <= MIN_QUANTITY) {
                    minusBtn.style.display = "none";
                }
            }
        }

        const event = new Event('change')
        input.dispatchEvent(event)
      }

      document.querySelectorAll('[data-mode="minus"]').forEach(minusBtn => {
        const input = minusBtn.closest('.quantity-wrapper').querySelector('input');
        if(input && parseInt(input.value) > MIN_QUANTITY) {
          minusBtn.style.display = "";
        } else {
          minusBtn.style.display = "none";
        }
      });
    }

    observeSelector('input[name="purchase_type"], input[name*="skio-group"]', purchase_type_input => {

      // init new theme
      if(document.querySelectorAll('input[skio-one-time]').length > 0){
        document.querySelector('body').setAttribute("data-selected-plan", "one-time");
      }

      purchase_type_input.addEventListener("change", () => {

        if(document.querySelectorAll('input[name="purchase_type"]').length > 0){
          
          // og theme
          /*
          if(document.querySelector('input[name="purchase_type"]:checked').value == "autodeliver"){
            document.querySelector('.js-button-mask').style.display = "block";
          } else {
            document.querySelector('.js-button-mask').style.display = "none";
          }
          */
          
        } else if(document.querySelectorAll('input[skio-one-time]').length > 0){
          
          // new theme
          if(document.querySelectorAll('input[skio-one-time]:checked').length > 0){
            document.querySelector('body').setAttribute("data-selected-plan", "one-time");
            // document.querySelector('.js-button-mask').style.display = "block";
          } else {
            document.querySelector('body').setAttribute("data-selected-plan", "subscription");
            // document.querySelector('.js-button-mask').style.display = "none";
            document.querySelector('input[name="one_time_size"][value="3"]').checked = true;
          }

        }

      });
    });

    observeSelector('input[name="one_time_size"], input[skio-one-time]', one_time_input => {
      
      one_time_input.addEventListener("change", () => {

        let one_time_selection = document.querySelector('input[name="one_time_size"]:checked').value;
        let quantityInput = document.querySelector('input[name="quantity"]');
        let minusButton = quantityInput.previousElementSibling;
        
        quantityInput.value = parseInt(one_time_selection);
        
        if(one_time_selection === "1") {
          minusButton.style.display = "";
        } else {
          if(parseInt(one_time_selection) > 1) {
            minusButton.style.display = "";
          } else {
            minusButton.style.display = "none";
          }
        }

        console.log("update the thing", one_time_selection);

        // Check if Black Friday mode is enabled
        const isBlackFridayMode = window.Shopify && window.Shopify.theme && window.Shopify.theme.settings && 
                                  window.Shopify.theme.settings.black_friday_mode === true;

        let price_html = `$15.00`;
        let savings_percentage = 0;

        // document.querySelector('.js-button-mask').style.display = "none";

        if(one_time_selection == "1"){
          if(isBlackFridayMode) {
            price_html = `<s style="opacity: 0.35;">$15.00</s> $12.00`;
            savings_percentage = 20;
          } else {
            price_html = `$15.00`;
            savings_percentage = 0;
          }
          // document.querySelector('.js-button-mask').style.display = "block";
        } else if(one_time_selection == "3"){
          if(isBlackFridayMode) {
            price_html = `<s style="opacity: 0.35;">$15.00</s> $12.00`;
            savings_percentage = 20;
          } else {
            price_html = `<s style="opacity: 0.35;">$15.00</s> $13.00`;
            savings_percentage = 13.3;
          }
          // document.querySelector('.js-button-mask').style.display = "block";
        } else if(one_time_selection == "6"){
          price_html = `<s style="opacity: 0.35;">$15.00</s> $12.00`;
          savings_percentage = 20;
          // document.querySelector('.js-button-mask').style.display = "block";
        } 

        setTimeout(() => {

          if(document.querySelectorAll('.buy-once-price').length > 0){
            document.querySelector('.buy-once-price').innerHTML = price_html;
          }

          if(document.querySelectorAll('[skio-onetime-price]').length > 0){
            document.querySelector('[skio-onetime-price]').innerHTML = price_html;
          }
          
        }, 50)
        
        
        document.querySelector('.js-onetime--savings span').innerHTML = `Save ${savings_percentage} %`;

      });
    })

    observeSelector('product-form form button[name="add"], .product-content form button[name="add"]', atc => {
      atc.parentNode.style.position = "relative";
      atc.insertAdjacentHTML("afterend", `<div class="js-button-mask">&nbsp;</div>`);
    })

    observeSelector('.js-button-mask', js_atc => {
      js_atc.addEventListener("click", () => {
        let one_time_selection = parseInt(document.querySelector('input[name="one_time_size"]:checked').value);

        // og theme
        let var_id = parseInt(document.querySelector('input[type="hidden"][name="id"]').value);
        let qty = parseInt(document.querySelector('input[name="quantity"]').value);
        let selling_plan_id = parseInt(document.querySelector('input[type="hidden"][name="selling_plan"]').value);

        if(document.querySelectorAll('#product-content form input[type="hidden"][name="id"]').length > 0){

          // new theme
          var_id = parseInt(document.querySelector('#product-content form input[type="hidden"][name="id"]').value);
          qty = parseInt(document.querySelector('#product-content form input[name="quantity"]').value);
          selling_plan_id = parseInt(document.querySelector('#product-content form select.delivery-input').value);

        }

        let payload = {
          items: [
            {
              id: var_id, // The product's variant ID
              quantity: qty, // Quantity to add to the cart
            },
          ],
        };

        const selected_plan = document.querySelector('body')?.getAttribute("data-selected-plan");
        const purchase_type = document.querySelector('input[name="purchase_type"]:checked')?.value;

        if (selected_plan === "subscription" || purchase_type === "autodeliver") {
          payload = {
            items: [
              {
                id: var_id, // The product's variant ID
                quantity: qty, // Quantity to add to the cart
                selling_plan: selling_plan_id
              },
            ],
          };
        }
      
        // Perform the fetch request to add the product to the cart
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(payload),
        }).then((response) => {
          if (response.ok) {
            // Redirect to the specified URL
            document.querySelector('[href="#offcanvas-cart"]').click()
            refreshCartContents();
            // window.location.href = `/discount/BUY${one_time_selection}ANDSAVE?redirect=${window.location.pathname}#cart`;
          } else {
            console.error('Error adding to cart:', response);
            alert('Failed to add product to the cart. Please try again.');
          }
        }).catch((error) => {
          console.error('Fetch error:', error);
          alert('An error occurred. Please try again.');
        });

      })
    })

  }).catch();

}
// END [WELL-02]

// START [WELL-11]
/*
waitUntil(() => {
    return document.querySelectorAll('label[for="size_three"]').length > 0 && document.querySelectorAll('.one-time-main.skio-group-container--selected').length > 0;
}).then(() => {

    if(window.location.href.indexOf("/products/charcoal-toothpaste") > -1 ||
    window.location.href.indexOf("/products/cinnamint-toothpaste") > -1 ||
    window.location.href.indexOf("/products/toothpaste") > -1 ||
    window.location.href.indexOf("/products/strawberry-toothpaste") > -1){

        // size_three exists (is the correct PDP)
        // and the one-time option is selected
        // document.querySelector('label[for="size_three"]').click();
        waitForElement('label[for="size_three"]').then(opt_3 => {

            // init
            opt_3.click();

        }).catch();

        document.querySelector('body').insertAdjacentHTML("afterbegin", `
        <style>
        [data-selected-plan="one-time"] .js-onetime {
            grid-template-columns: 1fr 1fr!important;
            .js-onetime--size[for="size_one"] {
                display: none!important;
            }
        }
        </style>
        `);
    } // if toothpaste PDP
}).catch();
*/
// END [WELL-11]

window.addEventListener("postscriptPopup", function(ev) {  
  window.dataLayer = window.dataLayer || [];
  const { values, popupName, popupId } = ev.detail;

  // ev.detail.type includes these values (hopefully others) [formSubmit, popupClose]
  
  dataLayer.push({
    'event': 'proteus_custom_event',
    'proteus_event_name': `PS ${ev.detail.type} - ${popupName} ${popupId}`,
    'proteus_event_category': "CRO",
    'page_location': window.location.href
  });

  console.log(`PS ${ev.detail.type} - ${popupName} ${popupId}`)

});

// SUPPORT FOR [WELL-15]
// hide stacking cart discounts
observeSelector('.product-item-price', cart_item_price => {
  console.log("init observe...")
  setTimeout(() => {
    let compare_items = cart_item_price.querySelectorAll('.product-item-price-compare');

    if (compare_items.length > 1) {
      compare_items.forEach((el, index) => {
        el.style.display = index === 0 ? '' : 'none';
      });
    }
  }, 50)
})

// WELL-07 now implemented in theme // 
// console.log("init [WELL-07] v1 -- 0.07");
// if(window.location.href.indexOf("/products/") > -1 && (window.location.href.indexOf("toothpaste") > -1 || window.location.href.indexOf("probiotic") > -1)){
//   // toothpaste OR probiotic PDP

//   // build nav items for toothpaste by default
//   let nav_html = `
//   <div class="js-toothpaste-nav">
        
//     <a class="js-toothpaste-nav--item" href="/products/toothpaste" style="background: url(https://wellnesse.com/cdn/shop/files/Untitled_design_10_100x.png) left center no-repeat;">
//       <span>Original Whitening</span>
//     </a>

//     <a class="js-toothpaste-nav--item" href="/products/cinnamint-toothpaste" style="background: url(https://cdn.shopify.com/s/files/1/0080/8229/2789/files/cinnamint_front_100x.png) left center no-repeat;">
//       <span>Cinnamint</span>
//     </a>

//     <a class="js-toothpaste-nav--item" href="/products/strawberry-toothpaste" style="background: url(https://wellnesse.com/cdn/shop/files/Untitled_design_7_6ac96735-b532-4205-aec0-d3ba2afe0c7b_100x.png) left center no-repeat;">
//       <span>Children’s Strawberry</span>
//     </a>

//     <a class="js-toothpaste-nav--item" href="/products/charcoal-toothpaste" style="background: url(https://wellnesse.com/cdn/shop/files/Untitled_design_6_cef23f94-2c58-474f-88e9-f37b868343ff_100x.png) left center no-repeat;">
//       <span>Charcoal</span>
//     </a>

//   </div>
//   `;

//   // alter nav for probiotic
//   if(window.location.href.indexOf("probiotic") > -1){
//     nav_html = `
//     <div class="js-toothpaste-nav">
          
//       <a class="js-toothpaste-nav--item" href="/products/probiotic-mints" style="background: url(https://cdn.shopify.com/s/files/1/0080/8229/2789/files/Untitled_design_-_2024-10-05T223902.090_d5eac62a-10ce-4c7a-bde2-8a09d26670e4_100x.png) left center no-repeat;">
//         <span>Mint</span>
//       </a>

//       <a class="js-toothpaste-nav--item" href="/products/raspberry-lemonade-probiotic" style="background: url(https://wellnesse.com/cdn/shop/files/1_630fce52-d647-41cd-abb4-56be7e9b3dfc_100x.png) left center no-repeat;">
//         <span>Raspberry Lemonade</span>
//       </a>

//     </div>
//     `;
//   }

//   observeSelector('div.product-price', pdp_price => {
//     if(document.querySelectorAll('.js-toothpaste-nav').length == 0){

//       pdp_price.insertAdjacentHTML("afterend", `
//       <style>
//       .js-toothpaste-nav{
//         display: grid;
//         grid-template-columns: 1fr 1fr 1fr 1fr;
//         gap: 15px;
//       }

//       .js-toothpaste-nav--item{
//         display: block;
//         align-content: center;
//         padding: 15px 15px 15px 45px;
//         border: 1px solid #0000003d;
//         color: #000;
//         border-radius: 15px;
//         font-size: 11px;
//         text-decoration: none;
//         background-blend-mode: multiply;
//         background-size: 50px !important;
//       }

//       .js-toothpaste-nav--item:hover{
//         background-color: #f3e1d7 !important;
//         cursor: pointer !important;
//       }

//       .js-toothpaste-nav--item.js-active{
//         border: 1px solid #df6459;
//         box-shadow: 0 0 1px .5px #e15e54;
//         color: #df6459;
//         pointer-events: none;
//       }

//       @media(max-width: 550px){
//       .js-toothpaste-nav{
//           grid-template-columns: 1fr 1fr;
//         }
//         .js-toothpaste-nav--item {
//           padding: 12px 12px 12px 30px;
//           background-position: -8px center !important;
//         }
//       }

//       </style>
//       <div class="description rte fs-2 fs-lg-2  text-uppercase">
//           <p>FLAVORS</p>
//       </div>
//       ${nav_html}
//       `);


//       observeSelector('.js-toothpaste-nav--item', nav_item => {
//         if(window.location.href.indexOf(nav_item.getAttribute("href")) > -1){
//           nav_item.classList.add("js-active");
//         }
//       })

//     }
    
//   });

// }

// console.log("init [WELL-02] v1 -- 0.07");

// if(window.location.href.indexOf("/products/") > -1 && window.location.href.indexOf("toothpaste") > -1 &&
//   window.location.href.indexOf("pack") == -1){

//   // a toothpaste item, but not a pack
  
//   if(window.location.href.indexOf("#cart") > -1){
//     waitForElement('[href="#offcanvas-cart"]').then(cart_trigger => {
//       setTimeout(() => {
//         cart_trigger.click();
//       }, 500);
//     }).catch();
//   }

//   waitForElement('label.buy_type.onetime > span, label.one-time-main.skio-group-container').then(one_time => {

//     one_time.insertAdjacentHTML("beforeend", `
    
//     <style>

//     [data-selected-plan] .skio-discount-badge {
//       position: absolute;
//       top: 0;
//       right: 0;
//       border-radius: 0 10px;
//       font-size: 10px;
//       background: #e15e54;
//       color: #fff;
//       padding: 6px 16px;
//       text-align: center;
//       letter-spacing: 2px;
//     }

//     /*
//     .ocu-popup {
//       display: none!important;
//     }
//     */

//     .js-onetime,
//     .js-onetime--savings{
//       display: none;
//     }

//     input.once-subscription:checked ~ .subscription_area_inner_once .js-onetime--savings,
//     [data-selected-plan="one-time"] .js-onetime--savings{
//       display: block;
//     }
      
//     input.once-subscription:checked{
//       margin-top: 12px;
//     }

//     .skio-group-container--selected,
//     .save-main.skio-group-container{
//       padding-top: 30px !important;
//     }

//     input.once-subscription:checked ~ .subscription-info-main,
//     [data-selected-plan="one-time"] input[skio-one-time] .subscription-info-main{
//       padding-top: 27px;
//     }
    
//     input.once-subscription:checked ~ .subscription_area_inner_once .js-onetime,
//     [data-selected-plan="one-time"] .js-onetime{
//       display: grid;
//       grid-template-columns: 1fr 1fr 1fr;
//       column-gap: 1.5rem;
//       width: 100%;
//       margin: 1em 2rem 1.5rem 0;
//     }

//     [data-selected-plan="one-time"] .js-onetime{
//       margin: 1em 0 0 0;
//     }
    
//     .js-onetime label {
//       display: inline-block;
//       text-align: center;
//       cursor: pointer;
//       position: relative;
//     }

//     .js-onetime label input{
//       display: none;
//     }
    
//     /* Style the span inside the labels */
//     .js-onetime label > span {
//       display: block;
//       padding: 10px;
//       border: 2px solid #ccc;
//       border-radius: 10px;
//       box-sizing: border-box;
//       transition: all 0.3s ease;
//     }
    
//     /* Highlight the label when the corresponding input is checked */
//     .js-onetime input:checked + span {
//       background: #e15e54;
//       border-color: #e15e54;
//       color: #fff;
//     }
    
//     /* Style the text inside the span */
//     .js-onetime label span small {
//       display: block;
//       font-size: 12px;
//       margin: 5px 0;
//     }
    
//     .js-onetime label span h2 {
//       font-weight: 900;
//       margin: 0;
//       font-size: 18px;
//       color: inherit;
//     }

//     [data-selected-plan] .js-onetime label span h2 {
//       font-weight: 400;
//     }

//     .js-button-mask{
//       position: absolute;
//       top: 3rem;
//       right: -1rem;
//       width: calc(100% - 140px);
//       height: 50px;
//       cursor: pointer;
//       /*  background: blue; */
//     }

//     [data-selected-plan] .js-button-mask{
//       top: 0;
//       right: 0;
//       width: calc(100% - 105px);
//       height: 100%;
//     }

//     @media(max-width: 768px){
//       .js-button-mask{
//         top: -5.75rem;
//       }
//       [data-selected-plan] .js-button-mask{
//         top: 0;
//       }
//     }

//     </style>

//     <div class="percentage__discount-container js-onetime--savings skio-discount-badge">
//       <span>Save 0 %</span>
//     </div>
    
//     <div class="js-onetime">
    
//       <label class="js-onetime--size" for="size_one">
//         <input class="once-subscription" type="radio" name="one_time_size" value="1" id="size_one" checked>
//         <span>
//           <small>Full Price</small>
//           <h2>1</h2>
//         </span>
//       </label>

//       <label class="js-onetime--size" for="size_three">
//         <input class="once-subscription" type="radio" name="one_time_size" value="3" id="size_three">
//         <span>
//           <small>Save $2</small>
//           <h2>3 tubes</h2>
//         </span>
//       </label>

//       <label class="js-onetime--size" for="size_six">
//         <input class="once-subscription" type="radio" name="one_time_size" value="6" id="size_six">
//         <span>
//           <small>Save $3</small>
//           <h2>6 tubes</h2>
//         </span>
//       </label>

//     </div>

//     `);

//     observeSelector('input[name="purchase_type"], input[name*="skio-group"]', purchase_type_input => {

//       // init new theme
//       if(document.querySelectorAll('input[skio-one-time]').length > 0){
//         document.querySelector('body').setAttribute("data-selected-plan", "subscription");
//       }

//       purchase_type_input.addEventListener("change", () => {

//         if(document.querySelectorAll('input[name="purchase_type"]').length > 0){
          
//           // og theme
//           /*
//           if(document.querySelector('input[name="purchase_type"]:checked').value == "autodeliver"){
//             document.querySelector('.js-button-mask').style.display = "block";
//           } else {
//             document.querySelector('.js-button-mask').style.display = "none";
//           }
//           */
          
//         } else if(document.querySelectorAll('input[skio-one-time]').length > 0){
          
//           // new theme
//           if(document.querySelectorAll('input[skio-one-time]:checked').length > 0){
//             document.querySelector('body').setAttribute("data-selected-plan", "one-time");
//             // document.querySelector('.js-button-mask').style.display = "block";
//           } else {
//             document.querySelector('body').setAttribute("data-selected-plan", "subscription");
//             // document.querySelector('.js-button-mask').style.display = "none";
//             document.querySelector('input[name="one_time_size"][value="1"]').checked = true;
//           }

//         }

//       });
//     });

//     observeSelector('input[name="one_time_size"], input[skio-one-time]', one_time_input => {
//       one_time_input.addEventListener("change", () => {
//         let one_time_selection = document.querySelector('input[name="one_time_size"]:checked').value;
//         document.querySelector('input[name="quantity"]').value = parseInt(one_time_selection);

//         let price_html = `$15.00`;
//         let savings_percentage = 0;

//         // document.querySelector('.js-button-mask').style.display = "none";

//         if(one_time_selection == "1"){
//           price_html = `$15.00`;
//           savings_percentage = 0;
//           // document.querySelector('.js-button-mask').style.display = "block";
//         } else if(one_time_selection == "3"){
//           price_html = `<s style="opacity: 0.35;">$15.00</s> $13.00`;
//           savings_percentage = 13.3;
//           // document.querySelector('.js-button-mask').style.display = "block";
//         } else if(one_time_selection == "6"){
//           price_html = `<s style="opacity: 0.35;">$15.00</s> $12.00`;
//           savings_percentage = 20;
//           // document.querySelector('.js-button-mask').style.display = "block";
//         } 

//         if(document.querySelectorAll('.buy-once-price').length > 0){
//           document.querySelector('.buy-once-price').innerHTML = price_html;
//         }

//         if(document.querySelectorAll('[skio-onetime-price]').length > 0){
//           document.querySelector('[skio-onetime-price]').innerHTML = price_html;
//         }
        
//         document.querySelector('.js-onetime--savings span').innerHTML = `Save ${savings_percentage} %`;

//       });
//     })

//     observeSelector('product-form form button[name="add"], .product-content form button[name="add"]', atc => {
//       atc.parentNode.style.position = "relative";
//       atc.insertAdjacentHTML("afterend", `<div class="js-button-mask">&nbsp;</div>`);
//     })

//     observeSelector('.js-button-mask', js_atc => {
//       js_atc.addEventListener("click", () => {
//         let one_time_selection = parseInt(document.querySelector('input[name="one_time_size"]:checked').value);

//         // og theme
//         let var_id = parseInt(document.querySelector('input[type="hidden"][name="id"]').value);
//         let qty = parseInt(document.querySelector('input[name="quantity"]').value);
//         let selling_plan_id = parseInt(document.querySelector('input[type="hidden"][name="selling_plan"]').value);

//         if(document.querySelectorAll('#product-content form input[type="hidden"][name="id"]').length > 0){

//           // new theme
//           var_id = parseInt(document.querySelector('#product-content form input[type="hidden"][name="id"]').value);
//           qty = parseInt(document.querySelector('#product-content form input[name="quantity"]').value);
//           selling_plan_id = parseInt(document.querySelector('#product-content form select.delivery-input').value);

//         }

//         let payload = {
//           items: [
//             {
//               id: var_id, // The product's variant ID
//               quantity: qty, // Quantity to add to the cart
//             },
//           ],
//         };

//         const selected_plan = document.querySelector('body')?.getAttribute("data-selected-plan");
//         const purchase_type = document.querySelector('input[name="purchase_type"]:checked')?.value;

//         if (selected_plan === "subscription" || purchase_type === "autodeliver") {
//           payload = {
//             items: [
//               {
//                 id: var_id, // The product's variant ID
//                 quantity: qty, // Quantity to add to the cart
//                 selling_plan: selling_plan_id
//               },
//             ],
//           };
//         }
      
//         // Perform the fetch request to add the product to the cart
//         fetch('/cart/add.js', {
//           method: 'POST',
//           headers: {
//             'Content-Type': 'application/json',
//           },
//           body: JSON.stringify(payload),
//         }).then((response) => {
//           if (response.ok) {
//             // Redirect to the specified URL
//             // window.location.href = `/discount/BUY${one_time_selection}ANDSAVE?redirect=${window.location.pathname}#cart`;
//             window.location.href = `${window.location.pathname}#cart`;
//           } else {
//             console.error('Error adding to cart:', response);
//             alert('Failed to add product to the cart. Please try again.');
//           }
//         }).catch((error) => {
//           console.error('Fetch error:', error);
//           alert('An error occurred. Please try again.');
//         });

//       })
//     })

//   }).catch();

// } // END [WELL-02] v1 -- 0.07


// wellnesse - 06 test implementation

if(getParam("best-offer") || window.sessionStorage.getItem("best-offer")){
  window.sessionStorage.setItem("best-offer", true);
}

if(!getParam("best-offer") && !window.sessionStorage.getItem("best-offer")){
  observeSelector('[data-cart-line-item]', cart_item => {
  
      if(cart_item.getAttribute("data-selling-plan")){
          let item_quantity = parseInt(cart_item.querySelector('input').value);
          let item_handle = cart_item.getAttribute("data-product-handle");
          
          if(item_handle == "toothpaste" ||
          item_handle == "charcoal-toothpaste" ||
          item_handle == "cinnamint-toothpaste" ||
          item_handle == "strawberry-toothpaste" ||
          item_handle == "vanilla-berry-toothpaste"){
              cart_item.querySelector('span.product-item-price-final').insertAdjacentHTML("afterend", `
                  <span class="product-item-price-compare text-muted ms-1">
                      <s>$${15 * item_quantity}.00</s>
                  </span>
              `);
          }
      }
  
      if(document.querySelectorAll('[data-cart-line-item][data-selling-plan]').length == 0){
  
          waitForElement('#cart-goal').then(cart_goal => {
  
              // no subscriptions
  
              let cart_items = document.querySelectorAll('[data-cart-line-item]');
              let toothpaste_count = 0;
  
              for(let i = 0; i < cart_items.length; i++){
                  let item_quantity = parseInt(cart_items[i].querySelector('input').value);
                  let item_handle = cart_items[i].getAttribute("data-product-handle");
                  
                  if(item_handle == "toothpaste" ||
                  item_handle == "charcoal-toothpaste" ||
                  item_handle == "cinnamint-toothpaste" ||
                  item_handle == "strawberry-toothpaste" ||
                  item_handle == "vanilla-berry-toothpaste"){
                      toothpaste_count += item_quantity 
                  }
              }
  
              let remaining_tubes = 6 - toothpaste_count;
              let tube_text = remaining_tubes === 1 ? "tube" : "tubes";
              let incentive_message = `<p><strong>Add ${remaining_tubes} more ${tube_text}</strong> to get <strong>20% off</strong></p>`;
  
              if(toothpaste_count < 3){
                  remaining_tubes = 3 - toothpaste_count;
                   tube_text = remaining_tubes === 1 ? "tube" : "tubes";
                  incentive_message = `<p><strong>Add ${remaining_tubes} more ${tube_text}</strong> to get <strong>13.3% off</strong></p>`;
              } 
  
              if(toothpaste_count < 6 && toothpaste_count > 0){
                  cart_goal.innerHTML = `
                  <div class="rte small mb-2 text-">
                      ${incentive_message}
                  </div>
  
                  <div class="progress" style="height: .5rem;">
                      <div class="progress-bar progress-bar progress-bar-animated progress-bar-striped bg-warning" role="progressbar" data-width="${(toothpaste_count/6) * 100}%" style="width: ${(toothpaste_count/6) * 100}%;">
                      </div>
                      
                      <div class="cart-goal-icon ">
                          
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-gift" viewBox="0 0 16 16" aria-hidden="true">
                              <path d="M3 2.5a2.5 2.5 0 0 1 5 0 2.5 2.5 0 0 1 5 0v.006c0 .07 0 .27-.038.494H15a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1v7.5a1.5 1.5 0 0 1-1.5 1.5h-11A1.5 1.5 0 0 1 1 14.5V7a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h2.038A2.968 2.968 0 0 1 3 2.506V2.5zm1.068.5H7v-.5a1.5 1.5 0 1 0-3 0c0 .085.002.274.045.43a.522.522 0 0 0 .023.07zM9 3h2.932a.56.56 0 0 0 .023-.07c.043-.156.045-.345.045-.43a1.5 1.5 0 0 0-3 0V3zM1 4v2h6V4H1zm8 0v2h6V4H9zm5 3H9v8h4.5a.5.5 0 0 0 .5-.5V7zm-7 8V7H2v7.5a.5.5 0 0 0 .5.5H7z"></path>
                          </svg>
                          
                      </div>
                      
                  </div>
                  `;
              }
  
              
          }).catch();
  
      } else {
          // has subscriptions -- do nothing
      }
      
  })
}
// END [WELL-06]
// [WELL-09] IMPLEMENTATION

observeSelector('#offcanvas-cart-wrapper .offcanvas-footer', cart_footer => {
    cart_footer.insertAdjacentHTML("beforebegin", `
    <style>
        .offcanvas-footer{
            display: flex;
            flex-wrap: wrap;
        }
        .offcanvas-footer > *{
            width: 100%;
            order: 1;
        }
        .offcanvas-footer form{
            order: 10;
        }
        .offcanvas-footer #offcanvas-cart-total-discount{
            order: 9;
        }
        .js-progress{
            font-size: 12px;
            font-weight: bold;
            font-family: 'Poppins';
            margin-bottom: -1rem;
            text-align: center;
        }
        .js-progress span{
            color: #0057b8;
            font-size: 9px;
            font-weight: 400;
        }
        .js-progress--bar{
            border: 1px solid #0057b8;
            padding: 1px;
            margin: .5rem 0;
        }
        .js-progress--filled{
            background: #0057b8;
            height: 10px;
        }
    </style>
    `);
    waitUntil(() => {
        return document.querySelectorAll('#offcanvas-cart-wrapper .offcanvas-footer .ecodrive-toggle').length > 0;
    }).then(() => {
        let oceans = document.querySelector('#offcanvas-cart-wrapper .offcanvas-footer .ecodrive-toggle');

        if(document.querySelectorAll('.js-progress').length == 0){

            oceans.insertAdjacentHTML("beforebegin", `
            <div class="js-progress">
                We are helping 4ocean protect and preserve our oceans. We've helped remove 3,500 pounds of plastic! Help us get to our 10,000 pounds goal.
                <div class="js-progress--bar">
                    <div class="js-progress--filled" style="width: 35%;"></div>
                </div>
                <div style="display: flex; justify-content: space-between;">
                    <span></span>
                    <span>3.5k lbs removed</span>
                    <span>10k lbs</span>
                </div>
            </div>
            `);
            
        }
    }).catch();
});

// START [WELL-18]
waitForElement('body').then(doc => {
  doc.insertAdjacentHTML("afterbegin", `
    <style>
      input[aria-label="Quantity"]{
        pointer-events: none !important;
      }
      .product-buy-buttons-inner.js-disclaimer:after{
        content: "Use 2 tubes over 60 days for best results!";
        position: absolute;
        bottom: -1.15rem;
        left: 0;
        width: 100%;
        font-size: 11px;
        opacity: .5;
      }
    </style>  
  `)
}).catch();

/*
14360165875765 - whitening
40022867443765 - charcoal
43542673391669 - cinnamint
40567724671029 - strawberry
*/

observeSelector('.card input[name="id"][value="14360165875765"], .card input[name="id"][value="40022867443765"], .card input[name="id"][value="43542673391669"], .card input[name="id"][value="40567724671029"]', toothpaste_id => {
  toothpaste_id.insertAdjacentHTML("afterend", `
    <input type="hidden" name="quantity" value="2">
  `);
});

if(window.location.href.indexOf("/products/toothpaste") > -1 || 
window.location.href.indexOf("/products/cinnamint-toothpaste") > -1 ||
window.location.href.indexOf("/products/strawberry-toothpaste") > -1 ||
window.location.href.indexOf("/products/charcoal-toothpaste") > -1 ||
window.location.href.indexOf(TOOTHPASTE_TEST_PATH) > -1){
  // is toothpaste PDP

  waitForElement('form[action="/cart/add"]').then(atc_form => {
    waitForElement('form[action="/cart/add"] input[aria-label="Quantity"]').then(qty => {

      let purchase_type = document.querySelectorAll('input[name*="skio-group"]');
      for(let i = 0; i < purchase_type.length; i++){
        purchase_type[i].addEventListener("change", () => {
          qty.previousElementSibling.removeAttribute("style")
          qty.parentNode.parentNode.classList.remove("js-disclaimer");
        });
      }
  
            qty.addEventListener("change", (e) => {
        if(document.querySelectorAll('input[skio-one-time]:checked').length > 0){
          // Allow quantity 1 for all toothpaste products in OTP mode
          qty.setAttribute('data-min-qty', MIN_QUANTITY);
          
          // Show/hide minus button based on quantity
          const minusBtn = e.target.previousElementSibling;
          if (e.target.value > MIN_QUANTITY) {
            minusBtn.style.display = "";
          } else {
            minusBtn.style.display = "none";
          }

          if(e.target.value == 2){
            e.target.parentNode.parentNode.classList.add("js-disclaimer");
          } else {
            e.target.parentNode.parentNode.classList.remove("js-disclaimer");
          }
          
          if(e.target.value > 1) {
            e.target.previousElementSibling.style.display = "";
          } else {
            e.target.previousElementSibling.style.display = "none";
          }

        } else {
          qty.setAttribute('data-min-qty', 1)
          e.target.previousElementSibling.removeAttribute("style")
          e.target.parentNode.parentNode.classList.remove("js-disclaimer");
        }
      })
      
    }).catch();
  }).catch();
}

observeSelector('[data-cart-line-item]', cart_item => {

  let toothpaste_count = 0;
  let cart_items = document.querySelectorAll('[data-cart-line-item]');
  let is_toothpaste = false;
  let is_toothpaste_test = false;
  const minusButton = cart_item.querySelector('[data-mode="minus"]');

  if(cart_item.getAttribute("data-product-handle") == "toothpaste" ||
  cart_item.getAttribute("data-product-handle") == "charcoal-toothpaste" ||
  cart_item.getAttribute("data-product-handle") == "cinnamint-toothpaste" ||
  cart_item.getAttribute("data-product-handle") == "strawberry-toothpaste"){
    is_toothpaste = true;
  }

  if(cart_item.getAttribute("data-product-handle") == "toothpaste-test"){
    is_toothpaste = true;
    is_toothpaste_test = true;
  }

  for(let i = 0; i < cart_items.length; i++){
      let item_quantity = parseInt(cart_items[i].querySelector('input').value);
      let item_handle = cart_items[i].getAttribute("data-product-handle");
      
      if(item_handle == "toothpaste" ||
      item_handle == "charcoal-toothpaste" ||
      item_handle == "cinnamint-toothpaste" ||
      item_handle == "strawberry-toothpaste"){
          toothpaste_count += item_quantity 
      }
  }

  if(cart_item.innerText.toLowerCase().indexOf("month") > -1){
    // is subscription item
  } else {
    let quantity_input = cart_item.querySelector('input');
    let item_quantity = parseInt(quantity_input.value);
    
    if(is_toothpaste){
      quantity_input.setAttribute('data-min-qty', MIN_QUANTITY);
    }
    
    // if(toothpaste_count < 3){
      
      let item_handle = cart_item.getAttribute("data-product-handle");

      if(item_quantity < 3 && 
        (item_handle == "toothpaste" ||
        item_handle == "charcoal-toothpaste" ||
        item_handle == "cinnamint-toothpaste" ||
        item_handle == "strawberry-toothpaste")){
            
          // is a toothpaste OTP item
          // cart_item.querySelector('.col-8.px-3').insertAdjacentHTML("beforeend", `
          //   <div style="padding: .5rem 0; opacity: .5; font-size: 11px;">
          //   Use 2 tubes over 60 days for best results!
          //   </div>  
          // `)
          cart_item.querySelector('.quantity-wrapper').parentNode.parentNode.insertAdjacentHTML("beforeend", `
            <div style="padding: .5rem 0; opacity: .5; font-size: 11px;">
            Use 2 tubes over 60 days for best results!
            </div>  
          `)

          if(item_quantity > 1) {
            minusButton.style.display = "";
          } else {
            minusButton.style.display = "none";
          }

        }

    // } // (toothpaste_count < 3)

  }
});
// END [WELL-18]

// START [WELL-12] (new users only)
if(!is_returning_user || window.sessionStorage.getItem("is-new-user")){
  console.log("is new user", is_returning_user)
  window.sessionStorage.setItem("is-new-user", true)
  waitForElement('body').then(doc => {
    doc.insertAdjacentHTML("afterbegin", `
    <style>
    #product-template form[data-variants*="oothpaste"] {
        h1.title:before {
            content: 'Hydroxyapatite Anticavity';
            display: block;
            font-size: 130%;
        }
        h1.title {
            font-size: 120%!important;
            padding-bottom: 8px;!important
        }
        h1.title:after {
            content: 'Helps reverse cavities & remineralize tooth enamel';
            display: block;
            font-size: 62.5%;
            margin-top: 10px;
            padding: 5px;
            border-radius: 10px;
            background: rgba(var(--bs-dark-rgb))!important;
            color: white;
            text-align: center;
        }
    }
    li[data-product-handle*="oothpaste"] h3 a:before {
        content: 'Hydroxyapatite Anticavity';
        display: block;
        font-size: 90%;
    }
    li[data-product-handle*="oothpaste"] h3 a {
        font-size: 90%;
    }
    </style>
    `);
  })
}
// END [WELL-12]